import { useState } from "react";
import { GuideModal } from "./GuideModal";
import { FeedbackModal } from "./FeedbackModal";
import { GUIDE_ENABLED } from "@/lib/env";

function UtilityButton({
  onClick,
  hoverColor,
  children,
}: {
  onClick: () => void;
  hoverColor: string;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="adm__utility-btn"
      onMouseEnter={(e) => {
        e.currentTarget.style.color = hoverColor;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "";
      }}
    >
      {children}
    </button>
  );
}

export function UtilityBar() {
  const [open, setOpen] = useState<null | "guide" | "feedback">(null);

  return (
    <div className="adm__utility">
      {GUIDE_ENABLED && (
        <UtilityButton onClick={() => setOpen("guide")} hoverColor="var(--ink)">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
          >
            <circle cx="6" cy="6" r="5" />
            <path d="M4.6 4.6a1.4 1.4 0 1 1 1.9 1.3c-.3.15-.5.4-.5.75v.35" />
            <path d="M6 9.1v.05" />
          </svg>
          How it works
        </UtilityButton>
      )}

      <UtilityButton
        onClick={() => setOpen("feedback")}
        hoverColor="var(--accent)"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        >
          <path d="M1.4 2.6h9.2v5.6H6.2L3.6 10.4V8.2H1.4z" />
          <path d="M6 4.2v1.8M6 7.05v.05" />
        </svg>
        Send feedback
      </UtilityButton>

      <GuideModal open={open === "guide"} onClose={() => setOpen(null)} />
      <FeedbackModal
        open={open === "feedback"}
        onClose={() => setOpen(null)}
      />
    </div>
  );
}
